import React                           from 'react';
import { smallestHoleSize as tooltip } from 'pu-data/Tooltips';
import CheckboxComponent               from './CheckboxComponent';

const SmallestHoleSize = (props) => {
  const name = 'smallest_hole_size';
  const onChange = e => props.onChangeParameter(name, e.target.checked ? '1' : '0');
  return (
    <CheckboxComponent
      name={name}
      inputId={name}
      label={props.label}
      tooltip={props.tooltip}
      checked={props.checked || props.parameters[name] === '1'}
      drawHidden={props.drawHidden}
      onChange={props.onChange || onChange} />
  );
};

SmallestHoleSize.defaultProps = {
  drawHidden: true,
  tooltip,
  label     : 'Smallest<br class="d-none d-lg-block" /> Hole Size',
};

export default SmallestHoleSize;
